import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface initialStateType {
  idDepartment: number | undefined;
  departmentName: string | undefined;
  idDepartmentRef: number | undefined;
  departmentStatus: string | undefined;
}
const initialState: initialStateType[] = [
  {
    departmentName: "",
    departmentStatus: "",
    idDepartment: undefined,
    idDepartmentRef: undefined,
  },
];

const DepartmentSlice = createSlice({
  name: "department",
  initialState,
  reducers: {
    setDepartment: (state, action: PayloadAction<initialStateType>) => {
      return [action.payload];
    },
  },
});

export const { setDepartment } = DepartmentSlice.actions;
export default DepartmentSlice.reducer;
